import styled from "styled-components";
import { css } from "styled-components";
import { responsiveMap } from "../../../../Grid/_utils/responsiveObserve";

export const _PetitPrincePriceListRoot = styled("div")<{}>(() => {
  return css`
    @media ${responsiveMap.maxLg} {
      margin-bottom: 0px;
    }
  `;
});
